import React from 'react';
import Profile from './Profile';


const ProfileView = (props) => { 
    return <Profile userData={props.userData} initialData={props.initialData} />
} 

export default ProfileView;